var map = {
	".": "3Fwp",
	"./": "3Fwp",
	"./01_listenKey": "jg15",
	"./01_listenKey.json": "jg15",
	"./02_balance": "W9nQ",
	"./02_balance.json": "W9nQ",
	"./03_order": "/xkA",
	"./03_order.json": "/xkA",
	"./04_setting": "pHnt",
	"./04_setting.json": "pHnt",
	"./index": "3Fwp",
	"./index.js": "3Fwp"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "z9PL";


//////////////////
// WEBPACK FOOTER
// ./src/config/zh-tw/swapV2/websocket/account ^.*$
// module id = z9PL
// module chunks = 3